import { render, staticRenderFns } from "./MediaMessagesList.vue?vue&type=template&id=65701382&scoped=true"
import script from "./MediaMessagesList.vue?vue&type=script&lang=js"
export * from "./MediaMessagesList.vue?vue&type=script&lang=js"
import style0 from "./MediaMessagesList.vue?vue&type=style&index=0&id=65701382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65701382",
  null
  
)

export default component.exports